import { actionHandler } from "../api";

const getCount = `api/method/guidestar.api.npo_profile_count.get_npo_profile_count`;

export const npoCount = async () => {
    try {
        // Convert the args object to a JSON string and encode it for use in a URL
        const { data } = await actionHandler({
            url: getCount,
            method: 'GET',
        });
        return data;
    } catch (error) {
        throw error;
    }
}